import BaseLocationList from './BaseLocationList';

export default BaseLocationList;
